import mutations from './dashboard/mutations';
import actions from './dashboard/actions';

const dashboard = {
  namespaced: true,
  state: {
    item: {},
    isLoading: false,
  },
  mutations,
  actions,
};

export default dashboard;
